import { lazy } from 'react';

// ----------------------------------------------------------------------

const BookingPage = lazy(() => import('../pages/Booking.page'));
const AddBookingPage = lazy(() => import('../pages/AddBooking.page'));
const BookingArchivePage = lazy(() => import('../pages/BookingArchive'));
const ContractArchivePage = lazy(() => import('../pages/ContractArchive'));

// ----------------------------------------------------------------------

const BookingRoutes = [
    {
        path: 'cars/booking',
        element: <BookingPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: 'cars/add-booking',
        element: <AddBookingPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: 'cars/booking-archive',
        element: <BookingArchivePage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: 'cars/contract-archive',
        element: <ContractArchivePage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { BookingRoutes };
